export interface CopilotChatSuggestion {
  title: string;
  message: string;
  partial?: boolean;
  className?: string;
}
